import { createReducer, on } from '@ngrx/store';
import { CatalogProductResponse } from '../../models/product-catalog.model';
import { ProductDetailResponse } from '../../models/product-detail.model';
import { TagMapping } from '../../models/tag-mapping.model';
import { CatalogActions } from './catalog.actions';

export interface CatalogState {
  products: CatalogProductResponse[];
  productsLoading: boolean;
  productsError: string | null;

  productDetails: Record<string, ProductDetailResponse>;
  productDetailsLoading: boolean;
  productDetailsError: string | null;
  productDetailLoadingCodes: Set<string>;

  tagMapping: TagMapping;
  tagMappingLoading: boolean;
  tagMappingError: string | null;
}

const initialState: CatalogState = {
  products: [],
  productsLoading: false,
  productsError: null,

  productDetails: {},
  productDetailsLoading: false,
  productDetailsError: null,
  productDetailLoadingCodes: new Set<string>(),

  tagMapping: {},
  tagMappingLoading: false,
  tagMappingError: null,
};

export const catalogReducer = createReducer(
  initialState,

  on(CatalogActions.loadCatalog, (state) => ({
    ...state,
    productsLoading: true,
    productsError: null,
  })),
  on(CatalogActions.loadCatalogSuccess, (state, { products }) => ({
    ...state,
    productsLoading: false,
    products,
  })),
  on(CatalogActions.loadCatalogFailure, (state, { error }) => ({
    ...state,
    productsLoading: false,
    productsError: error,
  })),

  on(CatalogActions.loadProductDetails, (state) => ({
    ...state,
    productDetailsLoading: true,
    productDetailsError: null,
  })),
  on(CatalogActions.loadProductDetailsSuccess, (state, { productDetails }) => ({
    ...state,
    productDetailsLoading: false,
    productDetails: { ...state.productDetails, ...productDetails },
  })),
  on(CatalogActions.loadProductDetailsFailure, (state, { error }) => ({
    ...state,
    productDetailsLoading: false,
    productDetailsError: error,
  })),

  on(CatalogActions.loadProductDetail, (state, { code }) => ({
    ...state,
    productDetailLoadingCodes: new Set([...state.productDetailLoadingCodes, code]),
  })),
  on(CatalogActions.loadProductDetailSuccess, (state, { code, productDetail }) => ({
    ...state,
    productDetails: { ...state.productDetails, [code]: productDetail },
    productDetailLoadingCodes: new Set([...state.productDetailLoadingCodes].filter(c => c !== code)),
  })),
  on(CatalogActions.loadProductDetailFailure, (state, { code }) => ({
    ...state,
    productDetailLoadingCodes: new Set([...state.productDetailLoadingCodes].filter(c => c !== code)),
  })),

  on(CatalogActions.loadTagMapping, (state) => ({
    ...state,
    tagMappingLoading: true,
    tagMappingError: null,
  })),
  on(CatalogActions.loadTagMappingSuccess, (state, { tagMapping }) => ({
    ...state,
    tagMappingLoading: false,
    tagMapping,
  })),
  on(CatalogActions.loadTagMappingFailure, (state, { error }) => ({
    ...state,
    tagMappingLoading: false,
    tagMappingError: error,
  }))
);
